import { Component } from '@angular/core';

import { ISocialMediaEntryEnvironment } from 'projects/shared/lib/interfaces/environment/social/social-entry-environment.interface';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';

@Component({
  selector: 'app-social-icons',
  imports: [],
  templateUrl: './social-icons.component.html',
  styleUrls: ['./social-icons.component.scss']
})
export class SocialIconsComponent {
  public socialMediaList: ISocialMediaEntryEnvironment[] | undefined;
  public constructor() {
    this.socialMediaList = ENVIRONMENT.social?.entries;
  }
}
